import type React from 'react';

import { MASK_OPTIONS } from '@vlabs/api-bindings/src/constants';
import { MaskIcon } from '@vlabs/icons';
import type { WithDataTestid, WithClassNameProp } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import { AttributeCard } from './attribute-card/AttributeCard';

interface MaskAttributeCardProps extends WithDataTestid, WithClassNameProp {
  mask: 1 | 2 | 3 | null;
}

export function MaskAttributeCard({
  mask,
  className = undefined,
  'data-testid': dataTestId = 'MaskAttributeCard',
  ...props
}: MaskAttributeCardProps): React.JSX.Element {
  const { t } = useTranslation();
  const description = MASK_OPTIONS[mask]?.label;

  return (
    <AttributeCard
      className={className}
      data={mask}
      data-testid={dataTestId}
      description={description}
      icon={<MaskIcon />}
      title={t('shared:attribute_cards.mask.title')}
      {...props}
    />
  );
}
